import { Tag as AntdTag } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { TagProps } from 'antd';

export const Tag = createGuardedComponent(AntdTag) as typeof AntdTag;
